'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdl';
var iconName = 'bookmark';
var width = 384;
var height = 512;
var aliases = [128278,61591];
var unicode = 'f02e';
var svgPathData = ['M32 32l0 440.3 143.9-83.9 16.1-9.4 16.1 9.4 143.9 83.9 0-440.3-320 0z', 'M192 379l16.1 9.4 143.9 83.9 0-440.3-320 0 0 440.3 143.9-83.9 16.1-9.4zM32 509.3L0 528 0 0 384 0 384 528 352 509.3 192 416 32 509.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookmark = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;